import React, { useEffect, useState } from "react";
import { getReminders } from "../../lib/api";
import { Card, Empty } from "./TvBits";

const fmt = new Intl.DateTimeFormat("en-US", { timeZone: "America/Chicago", weekday: "short", hour: "numeric", minute: "2-digit" });

export const TvReminders = ({ userId }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => getReminders(userId).then((r) => setRows(r || [])).catch(() => {});
    load(); const t = setInterval(load, 60000); return () => clearInterval(t);
  }, [userId]);
  const open = rows.filter((r) => !r.done);
  return (
    <Card title="REMINDERS" code={`${open.length} OPEN`} accent="#A78BFA" className="h-full" testid="tv-scene-reminders">
      <div className="h-full overflow-y-auto pr-2 flex flex-wrap content-start gap-3" data-testid="tv-reminder-chips">
        {open.map((r) => (
          <div key={r.id} className="nx-glass rounded-2xl px-5 py-3 max-w-full" data-testid={`tv-reminder-${r.id}`}>
            <p className="text-[clamp(1rem,1.4vw,1.75rem)] font-semibold text-cyan-50 line-clamp-2 break-words">{r.text}</p>
            {r.due_at && <p className="nx-mono text-[clamp(0.75rem,0.9vw,1.1rem)] text-violet-300/80 mt-1">{fmt.format(new Date(r.due_at))} CT</p>}
          </div>
        ))}
        {!open.length && <Empty>No open reminders.</Empty>}
      </div>
    </Card>
  );
};
